module.exports = __webpack_public_path__ + "static/media/precious_metals.5b29bc5a.png";